import { SaleItem } from '@/types/api/sale';
import SaleSection from './sale-section';

interface ProductsSectionProps {
  items: SaleItem[];
}

export default function ProductsSection({ items }: ProductsSectionProps) {
  return (
    // Beside the main section the list fills the row's height and scrolls, so the card is never taller than
    // the main section. Stacked in one column it gets a fixed max height instead, and alone in its row (below the
    // referral card) a minimum height so the list doesn't collapse.
    <SaleSection label="Produkter" bodyClassName="relative flex-1 p-0 min-h-0 md:min-h-72">
      <div className="max-h-96 overflow-y-auto overscroll-contain px-5 py-4 md:absolute md:inset-0 md:max-h-none">
        <div className="space-y-4 [&:not(:last-child)]:border-b">
          {items.map((item) => (
            <ProductRow
              key={item.product?.id ?? item.productId}
              name={item.product?.name!}
              quantity={item.quantity}
              imageUrl={item.product?.thumbnail?.url}
            />
          ))}
        </div>
      </div>
    </SaleSection>
  );
}

function ProductRow({ name, quantity, imageUrl }: { name: string; quantity: number; imageUrl?: string }) {
  return (
    <div className="flex gap-2">
      <img src={imageUrl} height={54} width={54} />
      <div className="flex justify-between items-center w-full">
        <div className="text-gray-500 dark:text-gray-400">{name}</div>
        <div>{quantity} st</div>
      </div>
    </div>
  );
}
